import { Box, Container, Stack, Typography, Button } from "@mui/material";
import "../../index.css";
import { useEffect } from "react";
import { ApiManager } from "../../utils/apiManager";
// import collectingMoneyGif from '../../assets/Collecting_Money_20260105064100.gif';

export default function Hero({ amount }: any) {
  useEffect(() => {
    const CheckFormValidity = async () => {
      try {
        const currentUrl = window.location.pathname;
        const parts = currentUrl.split("/").filter((part) => part !== "");
        var formNumber = parts.length > 0 ? parts[parts.length - 1] : "0";
        if (formNumber === "fest") {
          formNumber = "0";
        }
        await ApiManager.fetchWithAbort(
          `https://backend.app20.in/api/form/v2/check-form/?url=${formNumber}`
        );
      } catch (err) {
        console.log("Error:", err);
      }
    };
    CheckFormValidity();
  }, []);

  return (
    <Box
      id="hero"
      component="section"
      sx={{ position: "relative", width: "100%", background: "#FFFFFF", overflow: "hidden", pt: { xs: 14, md: 18 } }}
    >
      {/* Coins and sparkles, as on the app's splash screen */}
      <Box aria-hidden sx={{ position: "absolute", inset: 0, pointerEvents: "none" }}>
        {coins.map(({ size, ...pos }, i) => (
          <Box
            key={i}
            sx={{
              position: "absolute",
              ...pos,
              width: size,
              height: size,
              borderRadius: "50%",
              background: "radial-gradient(circle, #FFB300 0 60%, #FFD98A 61% 100%)",
              boxShadow: "0 14px 28px -10px rgba(191, 67, 0, 0.35)"
            }}
          />
        ))}
        {sparkles.map(({ size, ...pos }, i) => (
          <Box key={i} component="svg" viewBox="0 0 24 24" sx={{ position: "absolute", ...pos, width: size, height: size, color: "#FFB300" }}>
            <path d="M12 2l2.6 7.4L22 12l-7.4 2.6L12 22l-2.6-7.4L2 12l7.4-2.6L12 2z" fill="currentColor" />
          </Box>
        ))}
      </Box>

      <Container maxWidth="md" sx={{ position: "relative", textAlign: "center", pb: { xs: 7, md: 10 } }}>
        {/* Brand lockup */}
        <Box
          component="img"
          src="/koin_logo_yellow.png"
          alt=""
          sx={{
            width: { xs: 96, md: 124 },
            height: "auto",
            display: "block",
            mx: "auto",
            filter: "drop-shadow(0 18px 22px rgba(245, 124, 0, 0.28))",
            "@keyframes koinLogoIn": {
              from: { opacity: 0, transform: "translateY(16px) scale(0.92)" },
              to: { opacity: 1, transform: "none" }
            },
            animation: "koinLogoIn 800ms cubic-bezier(0.16, 1, 0.3, 1) both",
            "@media (prefers-reduced-motion: reduce)": { animation: "none" }
          }}
        />
        <Typography
          component="h1"
          sx={{
            mt: { xs: 4, md: 5 },
            mx: "auto",
            fontSize: { xs: "2.35rem", sm: "3.2rem", md: "4rem" },
            fontWeight: 700,
            lineHeight: 1.15,
            letterSpacing: "-0.01em",
            fontFamily: "General-Sans-bold, sans-serif",
            color: "#1F2937"
          }}
        >
          Simple tasks.
          <br />
          Daily rewards.
        </Typography>
        <Typography
          sx={{ mt: { xs: 2.5, md: 3 }, mx: "auto", maxWidth: "42ch", fontSize: { xs: "1.05rem", md: "1.2rem" }, lineHeight: 1.65, color: "#4B5563" }}
        >
          Complete a few steps for verified brands in the KOIN app, then withdraw your verified rewards to UPI.
        </Typography>

        <Stack direction={{ xs: "column", sm: "row" }} spacing={1.5} sx={{ mt: { xs: 4, md: 5 }, justifyContent: "center", alignItems: "center" }}>
          <Button
            id="hero-install-btn"
            variant="contained"
            href="https://play.google.com/store/apps/details?id=com.koinapp.co&hl=en_IN"
            target="_blank"
            startIcon={
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path d="M12 4v11m0 0l-4.5-4.5M12 15l4.5-4.5M5 19.5h14" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            }
            sx={{
              width: { xs: "100%", sm: "auto" },
              background: "linear-gradient(90deg, #FFB300 0%, #F57C00 100%)",
              color: "#FFF",
              borderRadius: "999px",
              textTransform: "none",
              fontSize: "1.05rem",
              fontWeight: 700,
              px: 4.5,
              py: 1.6,
              boxShadow: "0 14px 28px -10px rgba(245, 124, 0, 0.6)",
              fontFamily: "General-Sans-bold, sans-serif",
              "&:hover": { background: "linear-gradient(90deg, #FFA000 0%, #E65100 100%)", boxShadow: "0 16px 30px -10px rgba(230, 81, 0, 0.6)" },
              "&:focus-visible": { outline: "3px solid #1E5FA8", outlineOffset: 3 }
            }}
          >
            Download KOIN
          </Button>
          <Button
            href="#how-it-works"
            sx={{
              width: { xs: "100%", sm: "auto" },
              color: "#1F2937",
              borderRadius: "999px",
              textTransform: "none",
              fontSize: "1rem",
              fontWeight: 600,
              px: 3.5,
              py: 1.5,
              border: "1.5px solid #E5E7EB",
              background: "#FFF",
              fontFamily: "General-Sans-bold, sans-serif",
              "&:hover": { borderColor: "#FFB300", background: "#FFF8EC" },
              "&:focus-visible": { outline: "3px solid #1E5FA8", outlineOffset: 3 }
            }}
          >
            See how it works
          </Button>
        </Stack>

        <Box
          component="ul"
          sx={{ listStyle: "none", p: 0, m: 0, mt: { xs: 3.5, md: 4.5 }, display: "flex", flexWrap: "wrap", gap: { xs: 1.5, sm: 3 }, justifyContent: "center" }}
        >
          {["Free to join", "Verified brand campaigns", "UPI withdrawals"].map((t) => (
            <Box component="li" key={t} sx={{ display: "flex", alignItems: "center", gap: 1, fontSize: "0.95rem", fontWeight: 600, color: "#374151" }}>
              <Box component="span" aria-hidden sx={{ width: 20, height: 20, borderRadius: "50%", background: "#FFECC7", color: "#E65100", display: "grid", placeItems: "center" }}>
                <svg width="11" height="11" viewBox="0 0 12 12" fill="none"><path d="M2.5 6.2l2.3 2.3 4.7-5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" /></svg>
              </Box>
              {t}
            </Box>
          ))}
        </Box>
      </Container>

      {/* Orange wave: white bulges into orange, like the splash screen. Flows into How it works. */}
      <Box
        component="svg"
        aria-hidden
        viewBox="0 0 1440 140"
        preserveAspectRatio="none"
        sx={{ display: "block", width: "100%", height: { xs: 56, md: 110 }, mb: "-1px" }}
      >
        <path d="M0 0 Q720 150 1440 0 V140 H0 Z" fill="#F57C00" />
      </Box>
    </Box>
  );
}

const coins = [
  { top: { xs: 70, md: 110 }, left: { xs: -34, md: -40 }, size: { xs: 84, md: 150 } },
  { top: { xs: 150, md: 120 }, right: { xs: -26, md: "6%" }, size: { xs: 64, md: 96 } },
  { top: { md: 430 }, right: { md: "14%" }, size: { md: 46 }, display: { xs: "none", md: "block" } },
  { top: { md: 470 }, left: { md: "11%" }, size: { md: 38 }, display: { xs: "none", md: "block" } }
];

const sparkles = [
  { top: { xs: 120, md: 160 }, left: { xs: "26%", md: "30%" }, size: { xs: 16, md: 22 } },
  { top: { md: 280 }, right: { md: "28%" }, size: { md: 18 }, display: { xs: "none", md: "block" } }
];
